<div class="success-modal">
  <i class="bi bi-check-circle-fill" style="color:#007a47; font-size:3rem;"></i>

  <h2 class="title_success">¡Rechazado!</h2>

  <p class="parrafo_success">El camión se rechazó exitosamente.</p>

  <button type="button" class="btn btn-primary" (click)="close()">Aceptar</button>
</div>


